import { IMAGES } from "../constants/images";
import Sidebar from "../components/Sidebar";
import { useUser } from "../contexts/UserContext";
import useMoveTo from "../constants/navigation";
import { ROUTES } from "../App";
import MobileHeader from "../components/MobileHeader";
import { useState } from "react";
import ComingSoonPopup from "../components/ComingSoonPopup";

const VIP = () => {
    const navigate = useMoveTo();
    const { isHost } = useUser();
    const [showComingSoon, setShowComingSoon] = useState(false);


    return (
        <div className="flex flex-col h-screen bg-white text-black dark:bg-[#23272c] dark:text-white overflow-hidden">
            {/* Mobile Header */}
            <MobileHeader title="VIP"
                rightElement={isHost ? (
                    <button
                        onClick={() => {
                            console.log('');
                            console.log('='.repeat(60));
                            console.log('🚀 "BECOME A HOST" BUTTON CLICKED');
                            console.log('='.repeat(60));
                            console.log('📄 Navigating to subscription plan page...');
                            navigate(ROUTES.SUBSCRIPTION_PLAN);
                            console.log('✅ Navigation triggered - subscription plan will show');
                            console.log('='.repeat(60));
                        }}
                        className="px-4 py-2 rounded-md font-semibold text-xs bg-[#fef8dc] dark:bg-[#f6e38c11] text-[#EFBF04] dark:text-[#EFBF04] border border-[#EFBF04]">
                        👑 Pro Member
                    </button>
                ) : (
                    <button
                        onClick={() => {
                            console.log('');
                            console.log('='.repeat(60));
                            console.log('🚀 "BECOME A HOST" BUTTON CLICKED');
                            console.log('='.repeat(60));
                            console.log('📄 Navigating to subscription plan page...');
                            navigate(ROUTES.SUBSCRIPTION_PLAN);
                            console.log('✅ Navigation triggered - subscription plan will show');
                            console.log('='.repeat(60));
                        }}
                        className={`px-4 py-2 rounded-md font-semibold text-xs transition border border-[#327691] bg-[#327691] text-white dark:text-white`}
                    >
                        Access Pro
                    </button>
                )} />

            <div className="flex flex-1 overflow-hidden">
                {/* Sidebar */}
                <Sidebar />

                {/* Main Content */}
                <main className="flex-1 overflow-y-auto pt-5 pb-24 md:pb-5 px-6 bg-white text-black dark:bg-[#23272c] dark:text-white">
                    <div
                    >
                        {/* Top Header */}
                        <div className="flex items-center justify-between md:pb-4 pb-0">
                            <h2 className="text-xl md:text-3xl font-semibold mb-4 hidden md:block">VIP</h2>
                            <div className="w-5 md:hidden block" />
                            {isHost ? (
                                <button
                                    onClick={() => {
                                        console.log('');
                                        console.log('='.repeat(60));
                                        console.log('🚀 "BECOME A HOST" BUTTON CLICKED');
                                        console.log('='.repeat(60));
                                        console.log('📄 Navigating to subscription plan page...');
                                        navigate(ROUTES.SUBSCRIPTION_PLAN);
                                        console.log('✅ Navigation triggered - subscription plan will show');
                                        console.log('='.repeat(60));
                                    }}
                                    className="px-4 py-2 md:block hidden rounded-xl font-semibold bg-[#fef8dc] dark:bg-[#f6e38c11] text-[#EFBF04] dark:text-[#EFBF04] border border-[#EFBF04]">
                                    👑 Pro Member
                                </button>
                            ) : (
                                <button
                                    onClick={() => {
                                        console.log('');
                                        console.log('='.repeat(60));
                                        console.log('🚀 "BECOME A HOST" BUTTON CLICKED');
                                        console.log('='.repeat(60));
                                        console.log('📄 Navigating to subscription plan page...');

                                        // Always navigate to subscription plan page
                                        // The subscription plan page will handle IAP vs Stripe
                                        navigate(ROUTES.SUBSCRIPTION_PLAN);

                                        console.log('✅ Navigation triggered - subscription plan will show');
                                        console.log('='.repeat(60));
                                    }}
                                    className={`px-4 py-2 rounded-xl md:block hidden font-semibold transition border border-[#327691] bg-[#327691] text-white dark:text-white`}
                                >
                                    Access Pro
                                </button>
                            )}
                        </div>

                        {/* VIP Content */}
                        {/* VIP Product Cards */}
                        <div className="flex flex-col items-center justify-center h-full mt-2">
                            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-4 md:gap-8 w-full h-full max-w-full">
                                {[
                                    {
                                        name: "My Community",
                                        img: IMAGES.myCommunity,
                                        route: ROUTES.MY_COMMUNITY,
                                        clickable: true,
                                    },
                                    {
                                        name: "My Products",
                                        img: IMAGES.yourProducts,
                                        route: ROUTES.MY_PRODUCTS,
                                        clickable: true,
                                    },
                                    { name: "Coming Soon", img: IMAGES.comingSoon1, opacity: true, showText: true },
                                    { name: "Coming Soon", img: IMAGES.comingSoon2, opacity: true },
                                    { name: "Coming Soon", img: IMAGES.comingSoon3, opacity: true },
                                    { name: "Coming Soon", img: IMAGES.comingSoon4, opacity: true },
                                ].map((item, i) => (
                                    <div
                                        key={i}
                                        className={`flex flex-col items-center justify-center cursor-pointer ${item.opacity ? "opacity-80" : ""
                                            }`}
                                        onClick={() => {
                                            if (item.clickable) {
                                                navigate(item.route);
                                            } else if (item.opacity) {
                                                setShowComingSoon(true);
                                            }
                                        }}

                                    >
                                        <div className="relative flex flex-col items-center justify-center rounded-2xl shadow-lg transition-all duration-300 bg-[#F5F9FE] dark:bg-white text-black border border-gray-200 dark:border-0 hover:scale-105 w-full h-[20vh] sm:h-[24vh] md:h-[26vh] lg:h-[34vh]">
                                            <img
                                                src={item.img}
                                                alt={item.name}
                                                className={`w-[5rem] sm:w-[6rem] md:w-[8rem] lg:w-[10rem] object-contain mb-2 ${item.opacity ? "opacity-40" : ""
                                                    }`}
                                            />
                                        </div>
                                        {item.showText && (
                                            <span className="mt-2 sm:mt-3 text-sm sm:text-base md:text-lg font-semibold text-black dark:text-white md:block hidden" style={{ opacity: 0 }}>
                                                {item.name}
                                            </span>
                                        )}
                                        {!item.opacity && (
                                            <span className="mt-2 sm:mt-3 text-sm sm:text-base md:text-lg font-semibold text-black dark:text-white">
                                                {item.name}
                                            </span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>

                    <ComingSoonPopup
                        open={showComingSoon}
                        onClose={() => setShowComingSoon(false)}
                    />

                </main>
            </div>
        </div>
    );
}

export default VIP;
